// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
import { secundaryButton, transitionalButton, } from '../../../../global.style';
export const AssistanceDrawerContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: 24px 56px 56px;

  .drawer-assistance_item {
    gap: 24px;
    display: flex;
    padding: 20px 0;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--color-neutral-200);

    &:first-child {
      border-top: 1px solid var(--color-neutral-200);
    }

    .drawer-assistance_item-info {
      gap: 4px;
      display: flex;
      flex-direction: column;
    }

    p {
      margin: 0;
      font-size: var(--font-size-sm);
    }

    p.drawer-assistance_item-title {
      font-size: var(--font-size-default);
      font-weight: var(--font-weight-semibold);
    }

    p.drawer-assistance_item-hint {
      margin-top: 4px;
      font-weight: var(--font-weight-semibold);
      color: var(--color-brand-primary-500, var(--color-neutral-700));
    }

    p.drawer-assistance_item-feedback {
      margin-top: 4px;
      font-weight: var(--font-weight-semibold);

      &.success {
        color: var(--color-feedback-success-500);
      }

      &.error {
        color: var(--color-feedback-danger-500);
      }
    }

    button {
      ${transitionalButton}
      ${secundaryButton}

      flex-shrink: 0;
      padding: 8px 16px;
      white-space: nowrap;
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-semibold);
    }

    &.danger button {
      border-color: var(--color-feedback-danger-500);
      color: var(--color-feedback-danger-500);
    }
  }
`;
//# sourceMappingURL=style.js.map